export const CLOSE_CONTENT_ACCORDIONS_EVENT = 'CLOSE_CONTENT_ACCORDIONS_EVENT'
export const OPEN_CONTENT_ACCORDIONS_EVENT = 'OPEN_CONTENT_ACCORDIONS_EVENT'
